import ServerService from "../service/ServerService";
export async function fillTextPage(page,store,state=null){
    const data = (await ServerService.get_texts(page)).data
    if (!(data.status === 1)){
        return []
    }

    const texts_data = data.texts
    if (!store.user.lang && !localStorage.getItem("lang")){
        localStorage.setItem("lang","ru")
    }
    const lang_id = store.user.lang?store.user.lang:localStorage.getItem("lang");
    let dataLangs = {}
    //console.log(texts_data)
    for (let text_data of texts_data){
        dataLangs[text_data.id_text] = text_data[lang_id]
        // const elements = document.querySelectorAll(`[data-lang=${text_data.id_text}]`);
        // for (let element of elements){
        //     element.innerHTML = text_data["ru"]
        // }
    }
    //console.log(data,"data",page)
    await store.setDataLang(dataLangs)
    if (page!=="all"){
        store.setLoadText(true);

    }
    // Функция для поиска всех div внутри JSX компонента и извлечения их innerHTML
    if (state){
        state(false)
    }






}